import { DetailsClassInfoSectionCombinedProps } from './types';

const usePresenter = (props: DetailsClassInfoSectionCombinedProps): DetailsClassInfoSectionCombinedProps => {
  return props;
};

export default usePresenter;
